import React from 'react';

interface TabsProps {
  width?: number;
}

const Tabs = ({ width = 40 }: TabsProps) => (
  <svg width={width} height="32" viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d)">
      <path
        d="M16 27.5H23C24.1046 27.5 25 26.6046 25 25.5V2C25 0.89543 24.1046 0 23 0H16C14.8954 0 14 0.89543 14 2V25.5C14 26.6046 14.8954 27.5 16 27.5Z"
        fill="#9758F9"
      />
    </g>
    <g filter="url(#filter1_d)">
      <path
        d="M28 27.5H35C36.1046 27.5 37 26.6046 37 25.5V2C37 0.89543 36.1046 0 35 0H28C26.8954 0 26 0.89543 26 2V25.5C26 26.6046 26.8954 27.5 28 27.5Z"
        fill="#9758F9"
      />
    </g>
    <g filter="url(#filter2_d)">
      <path
        d="M2 2C2 0.89543 2.89543 0 4 0H11C12.1046 0 13 0.895431 13 2V4H36C37.1046 4 38 4.89543 38 6V25.5C38 26.6046 37.1046 27.5 36 27.5H4C2.89543 27.5 2 26.6046 2 25.5V2Z"
        fill="#6310E5"
      />
    </g>
    <rect x="6" y="9" width="28" height="2" rx="1" fill="#BFA6F4" />
    <rect x="20" y="15" width="14" height="1" rx="0.5" fill="#BFA6F4" />
    <rect x="20" y="21" width="11" height="1" rx="0.5" fill="#BFA6F4" />
    <rect x="20" y="18" width="14" height="1" rx="0.5" fill="#BFA6F4" />
    <rect x="6" y="14" width="12" height="10" rx="1" fill="#BFA6F4" />
    <defs>
      <filter
        id="filter0_d"
        x="12"
        y="0"
        width="15"
        height="31.5"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.2 0 0 0 0 0.215686 0 0 0 0 0.270588 0 0 0 0.08 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
      <filter
        id="filter1_d"
        x="24"
        y="0"
        width="15"
        height="31.5"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.2 0 0 0 0 0.215686 0 0 0 0 0.270588 0 0 0 0.08 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
      <filter
        id="filter2_d"
        x="0"
        y="0"
        width="40"
        height="31.5"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.2 0 0 0 0 0.215686 0 0 0 0 0.270588 0 0 0 0.08 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default Tabs;
